( function () {
	'use strict';

	const showMoreLinks = document.querySelectorAll( '.stats-numbers__showmore' );

	showMoreLinks.forEach( function( showMoreLink ) {
		const hiddenItems = showMoreLink.parentElement.querySelectorAll( '.stats--hidden' );

		showMoreLink.addEventListener( 'click', function( event ) {
			event.preventDefault();
			toggleHiddenItems( hiddenItems, showMoreLink );
		} );
	} );

	/**
     * Function to toggle visibility of hidden items
     */
	function toggleHiddenItems( hiddenItems, showMoreLink ) {
		hiddenItems.forEach( function( item ) {
			item.classList.toggle( 'stats--hidden' );
		} );

		// Toggle a class on the showMoreLink to indicate expanded/collapsed state
		showMoreLink.classList.toggle( 'expanded' );

		// Change link text based on the presence of the 'expanded' class
		if ( showMoreLink.classList.contains( 'expanded' ) ) {
			showMoreLink.textContent = 'Show less';
		} else {
			showMoreLink.textContent = 'Show more';
		}
	}

} )();

